export interface StudentResponseApi {
  studentId: string;
  studentName: string;
  studentPassword: string | null;
}

export let isStudentResponseDTO = (
  variable: unknown
): variable is StudentResponseApi => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "object" &&
    "studentId" in variable &&
    typeof variable.studentId === "string" &&
    "studentName" in variable &&
    typeof variable.studentName === "string"
  );
};

export class EmptyStudentResponseImpl implements StudentResponseApi {
  studentId: string = "";
  studentName: string = "";
  studentPassword: string | null = null;
}
